import React, { useEffect, useState } from "react";
import Preloading from "../../../components/basics/Preloading";
import back from "../../../assets/images/icons/arrow-right2.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import methods from "../../../services/utility";
import apiMethod from "../../../services/api-service";
import Paginations from "../../../components/paginaton/Paginations";
import DeleteModal from "../../../components/deleteModal/DeleteModal";
import EditIcon from "../../../assets/images/icons/editIcon.svg";
import DeleteIcon from "../../../assets/images/icons/deleteIcon.svg";
import newLogo from "../../../assets/images/icons/new.png";
import copy from "../../../assets/images/icons/copy.png";

const CategoryWarehouse = () => {
  const { restaurantId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [gridData, setGridData] = useState([]);
  const [selectId, setSelectId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [filterModel, setFilterModel] = useState({
    branchId: "",
    restaurantId: restaurantId,
    parentId: "",
    title: "",
    code: "",
    size: 10,
    part: 1,
    parts: 0,
    total: 0,
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    code: "",
    description: "",
    parentId: null,
    branchId: null,
    restaurantId: restaurantId,
  });

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.code = "";
    formModel.description = "";
    formModel.parentId = null;
    formModel.branchId = null;
    formModel.restaurantId = restaurantId;
    setFormModel({ ...formModel });
  };

  const resetFilters = () => {
    filterModel.branchId = "";
    filterModel.restaurantId = restaurantId;
    filterModel.parentId = "";
    filterModel.title = "";
    filterModel.code = "";
    filterModel.size = 10;
    filterModel.part = 1;
    filterModel.parts = 0;
    filterModel.total = 0;
    setFilterModel({ ...filterModel });
  };

  const getGridData = async (customPart = null) => {
    const part = customPart ? customPart : filterModel.part;
    setLoading(true);
    const resp = await apiMethod.getWarehouseCategories(
      filterModel.branchId,
      filterModel.parentId,
      filterModel.restaurantId,
      filterModel.title,
      filterModel.size,
      part
    );

    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      filterModel.part = part;
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, []);

  const callPager = async (i) => {
    setLoading(true);
    setFilterModel({ ...filterModel, part: i });
    await getGridData(i);
    setLoading(false);
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };
  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    resetForm();
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getWarehouseCategoryInfo(id);
    if (methods.showApiErrors(resp)) {
      setFormModel({
        ...formModel,
        id: resp.data.id,
        title: resp.data.title,
        description: resp.data.description,
        code: resp.data.code,
      });
    }
    setLoading(false);
  };

  const selectItemToDelete = (item) => {
    setSelectId(item);
    setShowDeleteModal(true);
  };

  const addCategory = async () => {
    setLoading(true);
    const resp = await apiMethod.createWarehouseCategory(formModel);
    if (methods.showApiErrors(resp)) {
      resetForm();
      await getGridData();
    }
    setLoading(false);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeWarehouseCategory(selectId.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const subCategories = async (item) => {
    setLoading(true);
    navigate(`/wareHouse/${restaurantId}/createCategoryWarehouse/${item.id}`);
    await getGridData();
    setLoading(false);
  };

  const copyItem = (item) => {
    formModel.title = item.title;
    formModel.description = item.description;
    setFormModel({ ...formModel });
    const el = document.getElementById("add_item");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading />}
        <div className="d-none d-lg-block mb-3">
          <Link
            to={`/warehouse/${restaurantId}`}
            className="text-start mb-3 link back-link"
          >
            <span>
              <img src={back} alt="return" />
            </span>
            بازگشت
          </Link>
        </div>
        <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
          <div>
            <Link to={`/${restaurantId}/dashboard`} className="link back-link">
              <span>
                <img src={back} alt="return" />
              </span>
            </Link>
            دسته بندی انبار
          </div>
          <p className="date">{methods.currentDate()}</p>
        </div>
        <div className="saleheader d-none d-lg-block">
          <p>
            دسته بندی انبار
            <a
              href={`/sale/${restaurantId}/softwareGuide/#section7`}
              className="link rtlicon me-1"
              title="برای اطلاعات بیشتر کلیک کنید"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-question-circle"></i>
            </a>
          </p>
        </div>
        <div className="salemain mb-3" id="add_item">
          <div className="d-flex align-items-center gap-4 justify-content-end">
            <button className="btn-action" onClick={resetForm}>
              <img src={newLogo} alt="Image" />
              <span style={{ fontSize: "12px" }}>جدید</span>
            </button>
          </div>
          <div className="mb-3">
            <span className="fw-bold fs-5">افزودن / ویرایش دسته بندی جدید</span>
          </div>
          <div className="col-12 mb-4">
            <label className="form-label required-label">عنوان</label>
            <input
              className="form-control input-form"
              type="text"
              style={{ direction: "rtl", textAlign: "right" }}
              value={formModel.title}
              onChange={(e) =>
                setFormModel({ ...formModel, title: e.target.value })
              }
              placeholder="عنوان را بنویسید"
            />
          </div>
          <div className="col-12">
            <label className="form-label">توضیحات</label>
            <textarea
              className="form-control input-textarea"
              rows={4}
              style={{ direction: "rtl", textAlign: "right" }}
              value={formModel.description}
              onChange={(e) =>
                setFormModel({ ...formModel, description: e.target.value })
              }
              placeholder="توضیحات را بنویسید"
            ></textarea>
          </div>
          <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
            <button
              type="button"
              className="btn custome-btn btn-link-purple"
              onClick={resetForm}
            >
              انصراف
            </button>
            <button
              type="button"
              className="btn custome-btn btn-purple"
              onClick={addCategory}
            >
              ثبت و ذخیره
            </button>
          </div>
        </div>
        <div className="salemain mb-3">
          <div className="row align-items-end g-3">
            <div className="col-3 d-flex flex-column gap-2">
              <label htmlFor="title">عنوان</label>
              <input
                type="text"
                className="form-control input-form"
                id="title"
                value={filterModel.title}
                onChange={(e) =>
                  setFilterModel({
                    ...filterModel,
                    title: e.target.value,
                    part: 1,
                  })
                }
                placeholder="جستجو کنید..."
              />
            </div>
            <div className="col-2">
              <div className="d-flex align-items-center gap-2">
                <button className="btn-wrap search-btn" onClick={searchItem}>
                  <i className="bi bi-search"></i>
                </button>
                <button className="btn-wrap reset-btn" onClick={clearSearch}>
                  <i className="bi bi-arrow-clockwise"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="salemain">
          <div className="d-flex align-items-center justify-content-between">
            <span className="d-block text-start fw-bold fs-5">
              دسته بندی انبار
            </span>
          </div>
          <div className="table-responsive warhousetable">
            <table className="table table-md table-custom">
              <thead>
                <tr>
                  <th scope="col" width="20px">
                    ردیف
                  </th>
                  <th scope="col">عنوان</th>
                  <th scope="col">توضیحات</th>
                  <th scope="col">زیر دسته</th>
                  <th scope="col" width="100px">
                    عملیات
                  </th>
                </tr>
              </thead>
              <tbody>
                {gridData.map((item, index) => (
                  <tr
                    key={item.id}
                    className={index % 2 === 0 ? "row-even" : "row-odd"}
                  >
                    <td>
                      {(filterModel.part - 1) * filterModel.size + index + 1}
                    </td>
                    <td>{item.title}</td>
                    <td>{item.description}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-outline-purple"
                        onClick={() => subCategories(item)}
                      >
                        زیر دسته
                      </button>
                    </td>
                    <td className="d-flex align-items-center justify-content-center gap-2">
                      <button
                        className="button-action copy-btn"
                        onClick={() => copyItem(item)}
                      >
                        <img src={copy} alt="Copy" />
                      </button>
                      <button
                        onClick={() => editItem(item.id)}
                        className="button-action"
                        type="button"
                      >
                        <img src={EditIcon} alt="Edit" />
                      </button>
                      <button
                        onClick={() => selectItemToDelete(item)}
                        className="button-action"
                        type="button"
                      >
                        <img src={DeleteIcon} alt="delete" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filterModel.parts > 1 && (
              <div className="pagination justify-content-center mt-5">
                <Paginations
                  total={filterModel.total}
                  size={filterModel.size}
                  onPageChange={callPager}
                />
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      {renderItems()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={"دسته بندی انبار"}
        />
      )}
    </div>
  );
};

export default CategoryWarehouse;
